import SimpleBannerRepository from "../SimpleBannerRepository"

export default class FaqSimpleBanner extends SimpleBannerRepository {
    static schemaId = "faq_banner"

    constructor() {
        super(FaqSimpleBanner.schemaId)
    }
}
